var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableBaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 6,
    height: 15,
    stroke: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 3,
    height: 15,
    stroke: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 7.5,
    width: 9,
    height: 15,
    transform: "rotate(90 19.5 7.5)",
    stroke: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 10.5,
    width: 3,
    height: 15,
    transform: "rotate(90 19.5 10.5)",
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBaseIcon);
export default __webpack_public_path__ + "static/media/table-base-icon.23aba0bb3f22b92b51ea4142e4ff476e.svg";
export { ForwardRef as ReactComponent };